import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Row, snackbarVariants } from '../../../utilities/constants';
import {
  attachPaymentMethod,
  getPaymentMethods,
  getStripeCustomer,
} from '../../../api/api-functions';
import { retryInvoice, updateBillingInfo } from '../../../pages/Products/api';

import BillingDetails from '../RegistrationCheckoutForm/BillingDetails';
import ButtonWithLoader from '../../../pure-ui/ButtonWithLoader/ButtonWithLoader';
import InvoiceSummary from './InvoiceSummary';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
const mapCardToCustomerBilling = (pm) => {
  const addr = pm?.billing_details?.address || {};
  return {
    paymentAddress: addr.line1 ?? '',
    paymentCity: addr.city ?? '',
    paymentCountry: addr.country ?? '',
    paymentState: addr.state ?? '',
    paymentZIP: addr.postal_code ?? '',
  };
};
const EMPTY_BILLING = {
  name: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  paymentAddress: '',
  paymentAddress2: '',
  paymentCity: '',
  paymentState: '',
  paymentZIP: '',
  paymentCountry: '',
};
const toStripeBilling = (f) => ({
  name: f?.name || `${f?.firstName ?? ''} ${f?.lastName ?? ''}`.trim() || undefined,
  email: f?.email || undefined,
  phone: f?.phone || undefined,
  address: {
    line1: f?.paymentAddress || '',
    line2: f?.paymentAddress2 || undefined,
    city: f?.paymentCity || '',
    state: f?.paymentState || undefined,
    postal_code: f?.paymentZIP || '',
    country: f?.paymentCountry || '',
  },
});
const RetryInvoice = (props) => {
  const {
    stripe,
    elements,
    paymentElement,
    invoice,
    setIsOpenCheckout,
    pendingInvoice,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [billingInfo, setBillingInfo] = useState(EMPTY_BILLING);
  const [userCards, setUserCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [addCard, setAddCard] = useState(false);
  const [isLoading, setisLoading] = useState('');

  const fetchStripeDetails = async () => {
    const customer = await getStripeCustomer();
    const defaultCard = customer?.invoice_settings?.default_payment_method;
    // setBillingInfo({
    //   paymentAddress: customer?.address?.line1,
    //   paymentCity: customer?.address?.city,
    //   paymentCountry: customer?.address?.country,
    //   paymentState: customer?.address?.state,
    //   paymentZIP: customer?.address?.postal_code,
    // });

    const rawCards = await getPaymentMethods();
    const cards = Array.isArray(rawCards) ? rawCards : [];
    const sortedCards = [...cards].sort((a, b) => {
      if (a.id === defaultCard) return -1;
      if (b.id === defaultCard) return 1;
    });
    setUserCards(sortedCards);
    if (sortedCards.length === 0) {
      setAddCard(true);
      setSelectedCard(null);
    } else {
      setAddCard(false);
      setSelectedCard(sortedCards[0]?.id);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchStripeDetails();
    };

    fetchData();
  }, []);

  const handleAddCard = async (ev) => {
    ev.preventDefault();
    setisLoading('addingCard');
    try {
      const { error: submitError } = await elements.submit();

      if (submitError) {
        enqueueSnackbar(
          'Please select a card or add a new one!',
          snackbarVariants.error
        );
        setisLoading('');
        return;
      }

      const newCard = await stripe.createPaymentMethod({
        elements,
        params: {
          billing_details: toStripeBilling(billingInfo),
        },
      });

      await attachPaymentMethod(newCard.paymentMethod.id);
      try {
        const billing = mapCardToCustomerBilling(newCard.paymentMethod);
        await updateBillingInfo(billing);
      } catch (billingError) {
        console.warn('Billing address update failed:', billingError);
      }
      await fetchStripeDetails();
      setSelectedCard(newCard.paymentMethod.id);
      const cardElement = elements.getElement('payment');
      cardElement.clear();
      setBillingInfo(EMPTY_BILLING);
      setAddCard(false);
      setisLoading('');
    } catch (error) {
      console.log('Error occured while adding card:', error);
      enqueueSnackbar(error?.response?.data?.Message || 'Failed to add card. Please try again.', snackbarVariants.error);
      setisLoading('');
    }
  };

  const handleFormSubmit = async (ev) => {
    ev.preventDefault();
    setisLoading(`subscribing-${selectedCard}`);
    const since = new Date().toISOString();
    const redirectPath = window.location.pathname;

    try {
      const response = await retryInvoice(invoice.id, selectedCard);

      if (response.status !== 200) {
        enqueueSnackbar(response?.statusText, snackbarVariants.error);
        setisLoading('');
        return;
      }

      setisLoading('');
      history.push(`/Processing?since=${encodeURIComponent(since)}&redirect=${encodeURIComponent(redirectPath)}`);
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.Message || 'Payment failed. Please try again.', snackbarVariants.error);
      setisLoading('');
    }
  };

  return (
    <Grid className="flex flex-col items-center w-full">
      <Paper
        style={{ boxShadow: 'none', width: '100%' }}
        className="w-[90%] max-w-[750px]"
      >
        <form
          onSubmit={handleFormSubmit}
          autoComplete="off"
          className="my-[60px]"
        >
          <>
            <InvoiceSummary invoice={invoice} />
            <Row style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}>
              <div className="md:p-[50px] p-3 max-w-[600px]">
                {(addCard || userCards.length === 0) && (
                  <>
                    {/* Payment Element Section */}
                    <div className="payment-section" style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '16px', marginBottom: 16 }}>
                      <Typography variant="h6" gutterBottom>
                        Payment Information
                      </Typography>
                      {paymentElement}
                    </div>

                    <BillingDetails
                      billingInfo={billingInfo}
                      setBillingInfo={setBillingInfo}
                    />
                  </>
                )}
                {addCard ? (

                  <div className="flex flex-row justify-center gap-x-3 mt-3">
                    <div className="flex flex-row">
                      <ButtonWithLoader
                        isLoading={isLoading === 'addingCard'}
                        onClick={handleAddCard}
                        title="Add New Card"
                        disabled={isLoading !== ''}
                      />
                    </div>
                    <Button
                      onClick={() => {
                        setBillingInfo(EMPTY_BILLING);
                        setAddCard(false)
                      }}
                      variant="outlined"
                      style={{
                        borderRadius: 8,
                        borderColor: 'black',
                        color: 'black',
                        textTransform: 'none',
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                ) : (
                  <div className="flex flex-row mb-3 w-full justify-center">
                    <Button
                      className="pb-3"
                      onClick={() => setAddCard(true)}
                      variant="contained"
                      style={{
                        borderRadius: 8,
                        backgroundColor: '#00A0E1',
                        color: '#fff',
                        textTransform: 'none',
                      }}
                      disabled={isLoading !== ''}
                    >
                      Add Card
                    </Button>
                  </div>
                )}
                <div className="md:p-[20px] p-2">
                  {userCards.map((card, index) => (
                    <div
                      key={card.id}
                      className="rounded-xl mt-3 border border-gray-300 border-solid w-full max-w-[600px] box-border bg-white shadow-sm p-3 sm:p-4"
                    >
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-start sm:items-center gap-3 min-w-0 w-full">
                          <img
                            className="w-[42px] sm:w-[50px] h-auto border border-gray-300 border-solid rounded-md shrink-0"
                            src={`/images/cards/${card.card.brand}.svg`}
                            alt={card.card.brand}
                          />
                          <div className="flex flex-col min-w-0 w-full">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3 w-full">
                              <div className="text-sm sm:text-lg font-bold leading-tight break-all sm:break-normal">
                                {`•••• •••• •••• ${card.card.last4}`}
                              </div>
                              {index === 0 && (
                                <div className="text-green text-xs sm:text-sm font-medium mt-1 sm:mt-0">
                                  Current Default
                                </div>
                              )}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-500 mt-1">
                              {card.card.brand?.toUpperCase()} • Expires {card.card.exp_month}/{card.card.exp_year}
                            </div>
                          </div>
                        </div>
                        <div className="w-full sm:w-auto">
                          <ButtonWithLoader
                            isLoading={isLoading === `subscribing-${card?.id}`}
                            onClick={() => setSelectedCard(selectedCard === card?.id ? null : card?.id)}
                            title={index === 0 ? 'Default' : 'Use Card'}
                            disabled={isLoading !== ''}
                            isProcessCompleted={selectedCard === card?.id}
                            titleOnComplete="Selected"
                            fullWidth
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            </Row>
          </>

          {/* Privacy Policy Agreement */}
          <div className="flex items-center gap-2 mb-2 mt-4 ml-16">
            <Checkbox
              checked={privacyPolicy}
              onChange={() => setPrivacyPolicy(!privacyPolicy)}
              style={{
                width: 12,
                height: 12,
                padding: '1px',
                borderRadius: '4px',
                color: '#6B7280',
                // @ts-ignore
                '&.Mui-checked': {
                  color: '#10B981',
                },
              }}
            />
            <span style={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '100%',
              color: '#6B7280',
            }}>
              I agree{' '}
              <a
                href="https://www.worldwideassist.net/privacypolicy.html"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#006080',
                  textDecoration: 'underline',
                }}
              >
                Privacy Policy
              </a>
            </span>
          </div>

          {/* Terms & Conditions Agreement */}
          <div className="flex items-center gap-2 mb-4 mt-2 ml-16">
            <Checkbox
              checked={termsAndConditions}
              onChange={() => setTermsAndConditions(!termsAndConditions)}
              style={{
                width: 12,
                height: 12,
                padding: '1px',
                borderRadius: '4px',
                color: '#6B7280',
                // @ts-ignore
                '&.Mui-checked': {
                  color: '#10B981',
                },
              }}
            />
            <span style={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '100%',
              color: '#6B7280',
            }}>
              I agree{' '}
              <a
                href="https://www.worldwideassist.net/terms-and-conditions.html"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#006080',
                  textDecoration: 'underline',
                }}
              >
                Terms and Conditions
              </a>
            </span>
          </div>
          <Row style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}>
            <ButtonWithLoader
              isLoading={isLoading === `subscribing-${selectedCard}`}
              disabled={
                isLoading !== '' ||
                !stripe ||
                !termsAndConditions ||
                !privacyPolicy ||
                !selectedCard
              }
              onClick={handleFormSubmit}
              title={
                isLoading === `subscribing-${selectedCard}`
                  ? 'Processing...'
                  : `PROCESS INVOICE`
              }
            />
          </Row>
          {!pendingInvoice && (
            <div className="flex flex-row w-full justify-center">
              <Button
                onClick={() => setIsOpenCheckout(false)}
                variant="outlined"
                style={{
                  borderRadius: 8,
                  borderColor: '#000',
                  color: '#000',
                  textTransform: 'none',
                }}
              >
                Back
              </Button>
            </div>
          )}
        </form>
      </Paper>
    </Grid>
  );
};

export default RetryInvoice;
